import styled, { css } from "styled-components";
import ReactInputMask from "react-input-mask";
import { Pagination as PaginationAnt } from "antd";
import IntlCurrencyInput from "react-intl-currency-input";

export const Container = styled.div`
  height: 100%;
  margin-top: 20px;
  width: 100%;
  overflow-x: scroll;
  padding-bottom: 80px;

  h2 {
    color: #001b22;
    font-weight: 400;
    margin: 0;
    line-height: 20px;
  }

  .error {
    width: 100%;
    color: #001b22;
    text-align: center;
    margin: 30px 0 50px 0;
    background: #f0f0f0;
    padding: 20px 15px;
    border-radius: 10px;
  }

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const Message = styled.div`
  width: 100%;
  background-color: #f0f0f0;
  border-radius: 5px;
  padding: 20px 40px;
  font-size: 16px;
  color: #000;
  text-align: center;
  margin: 25px 0;
`;

export const HeaderTitle = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  flex-wrap: wrap;
`;

export const Cards = styled.ul`
  margin: 20px 0 30px 0 !important;
  padding: 0px;
  display: flex;
  align-items: center;
`;

export const Card = styled.div`
  border-radius: 8px;
  width: 165px;
  height: 45px;
  padding: 0 25px;
  border-radius: 50px;
  margin-bottom: 15px;
  background: #008037;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 17px;
  font-family: Montserrat;
  color: #fff;
  font-weight: 600;
`;

export const Pagination = styled(PaginationAnt)`
  display: flex;
  justify-content: center;
  margin-top: 40px !important;
`;

export const ViewInput = styled.div`
  min-height: 40px;
  border-radius: 5px;
  width: 100%;
  margin-bottom: 5px;
  justify-content: space-between;

  p {
    width: 100%;
    font-size: 12px;
    text-align: left;
    margin: 0 0 2px 0;
  }
`;

export const InputMask = styled(ReactInputMask)`
  box-sizing: border-box;
  margin: 0;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  line-height: 1.5714285714285714;
  list-style: none;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue",
    Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol", "Noto Color Emoji";
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  background-color: #ffffff;
  background-image: none;
  border-width: 1px;
  border-style: solid;
  border-color: #d9d9d9;
  border-radius: 2px;

  transition: all 0.2s;
  ::placeholder {
    color: #bbb;
    font-size: 13px;
  }
  &:hover {
    border-color: #001b22;
  }
  &:focus {
    border-color: #001b22 !important;
    outline-color: #8e9094 !important;
    outline-width: 2px !important;
    outline-style: solid;
  }
`;

export const InputTel = styled(ReactInputMask)`
  box-sizing: border-box;
  margin: 0;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  line-height: 1.5714285714285714;
  list-style: none;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue",
    Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol", "Noto Color Emoji";
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  background-color: #ffffff;
  background-image: none;
  border-width: 1px;
  border-style: solid;
  border-color: #d9d9d9;
  border-radius: 2px;
  transition: all 0.2s;
  ::placeholder {
    color: #bbb;
    font-size: 13px;
  }
  &:hover {
    border-color: #001b22;
  }
  input:focus {
    border-color: #001b22;
  }
`;

export const InputValue = styled(IntlCurrencyInput)`
  width: 100%;
  background-color: #fff;
  border-width: 0;
  color: #000;
  padding: 6px 8px;
  font-size: 14;
  border-width: 1;
  border-color: #ccc;
  border-style: solid;
  border-radius: 2;
  font-weight: 400;
  padding-left: 12;

  transition: all 0.2s;
  ::placeholder {
    color: #bbb;
    font-size: 13px;
  }
  &:hover {
    border-color: #001b22;
  }
  &:focus {
    border-color: #001b22 !important;
    outline-color: #8e9094 !important;
    outline-width: 2px !important;
    outline-style: solid;
  }
`;

export const Scroll = styled.div`
  width: 100%;
  overflow-x: auto;
`;
export const Table = styled.table`
  width: 100%;
  margin-top: 25px;
  border: none;
  border-collapse: separate;
  color: #001b22;
  border-spacing: 0 1em;

  thead {
    tr {
      td {
        padding: 0 15px;
        text-align: center;

        &:last-child {
          text-align: center;
        }
      }
    }
  }

  tbody {
    tr {
      td {
        color: #001b22;
        font-size: 14px;
        height: 40px;
        padding: 0 15px;
        background: #f0f0f0;
        text-align: center;

        a {
          margin: 10px;
        }

        &:first-child {
          border-bottom-left-radius: 5px;
          border-top-left-radius: 5px;
        }

        &:last-child {
          text-align: center;
          border-bottom-right-radius: 5px;
          border-top-right-radius: 5px;
        }
      }
    }
  }
`;
